export function priceForBudget(rangeGoals) {
  if (!rangeGoals) return null;

  const key = String(rangeGoals)
    .replace(/,/g, "")
    .replace(/\s+/g, "")
    .replace(/TO/gi, "-")
    .replace(/[\u2013\u2014]/g, "-")
    .toUpperCase();

  if (key.includes("10K") && key.includes("25K")) {
    return { fee: 99, code: "FIRST50", firstLeadDiscount: 50 };
  }

  if (key.includes("26K") || key.includes("35K") || key.includes("50K")) {
    return { fee: 149, code: "FIRST50", firstLeadDiscount: 50 };
  }

  if (key.includes("50K") && key.includes("75K")) {
    return { fee: 199, code: "FIRST100", firstLeadDiscount: 100 };
  }

  if (key.includes("76K") || key.includes("100K") || key.includes("+")) {
    return { fee: 199, code: "FIRST100", firstLeadDiscount: 100 };
  }

  return null;
}
